import { teamEmailAddressSchema } from "@redotech/redo-model/email/domain-verification";
import * as z from "zod/v4";

export const sendVerificationEmail = {
  name: "sendVerificationEmail" as const,
  input: z.object({ address: teamEmailAddressSchema }),
  output: z.null(),
};
